<template lang="pug" src="./entryManager.pug"></template>

<script>
import moment from 'moment'
import language from '../../../../build/language/index'
import customSorter from '../../../utils/customSorter.js'
import { maskThousand } from '../../../utils/numberMasker.js'

moment.locale(language.getDatePickerLanguage())

export default {
  name: 'EntryManager',

  props: {
    entriesList: {
      type: Array,
      required: true
    },
    isInternal: {type: Boolean,
      required: true
    }
  },

  data () {
    return {
      sumAmount: 0.00,
      columns: ['dtLanc', 'valor', 'situacao', 'acoes'],
      options: {
        columnsClasses: {'acoes': 'col-md-1', 'dtLanc': 'col-md-2', 'valor': 'col-md-2 align-right', 'situacao': 'col-md-2'},
        headings: {
          dtLanc: this.$t('conciliacaoManual.labels.data'),
          valor: this.$t('conciliacaoManual.labels.valor'),
          situacao: this.$t('conciliacaoManual.labels.situacao'),
          acoes: ''
        },
        sortIcon: {
          is: ''
        },
        templates: {
          dtLanc: (h, row) => {
            let date = row.dtLanc ? row.dtLanc : row.data
            return moment(date).format('DD/MM/YYYY')
          },

          valor: (h, row) => {
            return maskThousand(row.valor)
          },

          situacao: (h, row) => {
            return row.situacao === 'A'
              ? this.$t('statusConciliacao.aberto')
              : row.situacao === 'C'
              ? this.$t('statusConciliacao.conciliado')
              : row.situacao === 'M'
              ? this.$t('statusConciliacao.conciliadoManualmente')
              : row.situacao === 'D'
              ? this.$t('statusConciliacao.divergente')
              : row.situacao === 'N'
              ? this.$t('statusConciliacao.naoAplicavel')
              : ' - '
          }
        },
        filterable: false,
        perPage: 9999,
        perPageValues: [],
        texts: {
          count: '',
          noResults: this.isInternal
            ? this.$t('conciliacaoManual.erro.nenhumLancamentoInterno')
            : this.$t('conciliacaoManual.erro.nenhumLancamentoBancario')
        },
        sortable: ['dtLanc', 'valor', 'situacao'],
        pagination: {},
        customSorting: {
          dtLanc: function (ascending) {
            return function (a, b) {
              a.nDate = a.dtLanc ? a.dtLanc : a.data
              b.nDate = b.dtLanc ? b.dtLanc : b.data
              return customSorter.dateSorter(ascending, a, b, 'nDate')
            }
          }
        }
      }
    }
  },

  computed: {
    totalAmountOfEntries () {
      return this.entriesList.length
    },

    sum () {
      let valueF = 0.00
      this.entriesList.forEach(entry => {
        valueF += entry.valor
      })
      this.sumAmount = valueF

      return maskThousand(valueF)
    },

    rangeDate () {
      let startDate = new Date('01/01/9999')
      let endDate = new Date('01/01/1900')
      this.entriesList.forEach(entry => {
        let date = entry.dtLanc ? entry.dtLanc : entry.data
        if (moment(date).isBefore(startDate)) {
          startDate = date
        }

        if (moment(date).isAfter(endDate)) {
          endDate = date
        }
      })

      return this.totalAmountOfEntries > 0
      ? startDate === endDate
      ? moment(startDate).format('DD/MM/YYYY')
      : moment(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + moment(endDate).format('DD/MM/YYYY')
      : ' - '
    }
  },

  watch: {
    sum () {
      let action = this.isInternal ? 'updateTotalAmountForInternalEntries' : 'updateTotalAmountForBankEntries'
      this.$store.dispatch(action, this.sumAmount)
        .then(() => {
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    }
  },

  methods: {
    removeEntry (entry) {
      // Remover da lista e do vuex
      let action = this.isInternal ? 'removeFinMov' : 'removeBankStat'
      let flag = this.isInternal ? 'hasPendingFinMov' : 'hasPendingBankStat'

      this.$store.dispatch(action, entry)
        .then(() => {
          // Remonta a respectiva grid, para evitar problemas quando as entradas estão ordenadas
          action === 'removeFinMov' ? window.Grids[0].Reload() : window.Grids[1].Reload()

          this.$store.dispatch(flag, true)
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    }
  }
}
</script>

<style>
.VueTables__table {
  margin-bottom: 1px!important;
}

.entry-table {
  max-height: 237px;
  overflow-x: hidden;
  overflow-y: auto;
  max-width: 98%;
}

.manage-value {
  text-align: center;
  font-weight: bold !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 3vh !important;
  text-transform: initial !important;;
}

.manage-date {
  text-align: center;
  font-weight: bold !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 2vh !important;
  text-transform: initial !important;;
}

td.align-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// EntryManager.vue?69648d52